
























import Vue from 'vue'
import Artifacts from '@/components/artifacts/Artifacts.vue'
import InterviewReport from '@/survey/InterviewReport.vue'

export default Vue.extend({
  components: {
    InterviewReport,
    Artifacts,
  },
  data() {
    return {
      interviewReport: {},
      defaults: {
        interviewer_id: null,
        case_id: null,

        patient_reached: undefined,
        contact_via: '',
        has_medication: undefined,
        medication_name: 'NA',

        had_previous_ilajnafsy_treatment: undefined,
        type_of_previous_ilajnafsy_treatment: '',
        finished_previous_ilajnafsy_treatment_weaks_ago: undefined,

        suicidality_c1: undefined,
        suicidality_c2: undefined,
        suicidality_c3: undefined,
        suicidality_c4: undefined,
        suicidality_c5: undefined,
        suicidality_c6: undefined,
        suicidality_suicide_risk: '',
        suicidality_no_suicide_contract: undefined,

        trauma_description: '',

        ptsd_checked: undefined,
        ptsd_b1: undefined,
        ptsd_b2: undefined,
        ptsd_b3: undefined,
        ptsd_b4: undefined,
        ptsd_b5: undefined,
        ptsd_c1: undefined,
        ptsd_c2: undefined,
        ptsd_d1: undefined,
        ptsd_d2: undefined,
        ptsd_d3: undefined,
        ptsd_d4: undefined,
        ptsd_d5: undefined,
        ptsd_d6: undefined,
        ptsd_d7: undefined,
        ptsd_e1: undefined,
        ptsd_e2: undefined,
        ptsd_e3: undefined,
        ptsd_e4: undefined,
        ptsd_e5: undefined,
        ptsd_e6: undefined,

        ptsd_b_fulfilled: undefined,
        ptsd_c_fulfilled: undefined,
        ptsd_d_fulfilled: undefined,
        ptsd_e_fulfilled: undefined,
        ptsd_f_fulfilled: undefined,
        ptsd_g_fulfilled: undefined,
        ptsd_h_fulfilled: undefined,
        ptsd_total_fulfilled: false,

        cmdr_a1: undefined,
        cmdr_a2: undefined,
        cmdr_a3: undefined,
        cmdr_a4: undefined,
        cmdr_a5: undefined,
        cmdr_a6: undefined,
        cmdr_a7: undefined,
        cmdr_a8: undefined,
        cmdr_a9: undefined,
        cmdr_a_fulfilled: undefined,
        cmdr_b_fulfilled: undefined,
        cmdr_c_fulfilled: undefined,
        cmdr_mde_total_fulfilled: false,

        cmd_actual_episode_starts_weeks: 0,
        cmd_actual_episode_starts_months: 0,
        cmd_last_episode_before_months: 0,
        cmd_last_episode_before_years: 0,
        cmd_number_of_episodes: 0,

        dysthymia_b1: undefined,
        dysthymia_b2: undefined,
        dysthymia_b3: undefined,
        dysthymia_b4: undefined,
        dysthymia_b5: undefined,
        dysthymia_b6: undefined,

        dysthymia_a_fulfilled: undefined,
        dysthymia_b_fulfilled: undefined,
        dysthymia_c_fulfilled: undefined,
        dysthymia_e_fulfilled: undefined,
        dysthymia_f_fulfilled: undefined,
        dysthymia_g_fulfilled: undefined,
        dysthymia_h_fulfilled: undefined,
        dysthymia_total_fulfilled: false,

        primary_problem: '',
        primary_problem_status_accepted: '',
        primary_problem_status_rejected: '',

        patient_accepted_for_counseling: undefined,
        reasons_for_counseling: '',
        accessibility_time: '',
        additional_comments: '',
        patient_needs_to_register_again: false,
        reasons_for_future_registration: '',
        state_if_other_reasons: '',
      },
      interviewer: {
        name: 'Randle Patrick McMurphy',
      },
      interviewee: {
        name: 'Norman Bates',
        aliasDuringInterviewAndTreatment: '',
        age: 28,
        sex: 'male',
        residence: 'USA',
        phoneNumber: '0173123456',
        zoomAccName: 'psycho1960',
        trauma: {
          traumaList: {
            trauma1: 'bsp.1',
            trauma2: 'bsp. 2',
          },
          traumaWorstEvent: 'badbadbad',
        },
      },
    }
  },
})
